import React from "react";
import { notify } from "@/shared/utils/notify";
import { productWarehousesService } from "../../../../shared/services";

export const useAssignProductWharehouse = () => {
  const [loading, setLoading] = React.useState<boolean>(false);

  const assignProductWharehouse = async ({
    warehouseId,
    productId,
  }: {
    warehouseId: number;
    productId: number;
  }) => {
    if (loading) return;
    setLoading(true);

    try {
      // Buscar el producto en la bodega
      const { data } = await productWarehousesService.find({
        query: {
          warehouse_id: +warehouseId,
          product_id: +productId,
        },
      });

      if (data && data.length === 0) {
        // Si el producto no está en la bodega, lo creamos
        await productWarehousesService.create({
          warehouse_id: +warehouseId,
          product_id: +productId,
          status: "active",  // Asignar estado 'active' directamente al crear
        });
        notify.success("Se ha asignado exitosamente el producto a la bodega", 2);
      } else {
        // Si el producto está en la bodega, actualizamos su estado a 'active'
        await productWarehousesService.patch(data[0].id, { status: "active" });
        notify.success("Se ha actualizado el producto a la bodega", 2);
      }
    } catch (err: any) {
      notify.error(err.message);
    } finally {
      setLoading(false);
    }
  };

  const removeProductWharehouse = async (
    warehouseId: number,
    productId: number
  ) => {
    if (loading) return;
    setLoading(true);

    try {
      // Buscar el producto en la bodega
      const { data } = await productWarehousesService.find({
        query: {
          warehouse_id: +warehouseId,
          product_id: +productId,
        },
      });

      if (data && data.length > 0) {
        // Si el producto está en la bodega, actualizamos su estado a 'inactive'
        await productWarehousesService.patch(data[0].id, { status: "inactive" });
        notify.success("Se ha removido exitosamente el producto de la bodega", 2);
      } else {
        // El producto no está en la bodega, mostrar mensaje adecuado
        notify.warning("El producto no está en la bodega", 2);
      }
    } catch (err: any) {
      notify.error(err.message);
    } finally {
      setLoading(false);
    }
  };

  return {
    assignProductWharehouse,
    removeProductWharehouse,
  };
};
